export function getEventTarget(event: Event) {
  return event.target
}
